import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, FakeText, IconButton } from '@totalsoft/rocket-ui';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import AssetHierarchyDetailsComponent from './AssetHierarchyDetailsComponent';

const AssetHierarchyDetailsCard = ({ hierarchy, image, actions }) => {
  const { t } = useTranslation();

  return (
    <Card
      icon={DirectionsCarIcon}
      iconColor='primary'
      title={hierarchy.header.name}
      actions={<IconButton type='cancel' color='transparent' tooltip={t('Close')} onClick={actions.onClose} />}
    >
      {hierarchy.data.loading ? (
        <FakeText lines={8} />
      ) : (
        <AssetHierarchyDetailsComponent hierarchy={hierarchy.data} image={image} actions={actions} />
      )}
    </Card>
  );
};

AssetHierarchyDetailsCard.propTypes = {
  hierarchy: PropTypes.object.isRequired,
  image: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

export default AssetHierarchyDetailsCard;
